module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Epigraph-rw exclude-auto-rw page-open-right-rw",
    attrs: {
      "epub:type": "frontmatter epigraph",
      "id": "Epigraph1"
    }
  }, [_c('div', {
    staticClass: "epigraph-rw",
    attrs: {
      "id": "epigraph1"
    }
  }, [_c('p', {
    staticClass: "ep1-rw",
    attrs: {
      "id": "p27"
    }
  }, [_vm._v("More than any other time in history mankind faces a crossroads. One path leads to despair and utter hopelessness, the other to total extinction. Let us pray we have the wisdom to choose correctly.")]), _vm._v(" "), _c('p', {
    staticClass: "source-rw",
    attrs: {
      "id": "source1"
    }
  }, [_vm._v("—Woody Allen")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ff8586e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s005-Epigraph-01.vue
// module id = 75
// module chunks = 0